import { Button, Stack, Typography } from "@mui/material";
import { skipToken } from "@reduxjs/toolkit/query";
import { useGetPatientIdentificationQuery } from "src/api/services/api";
import WhiteCard from "src/components/WhiteCard";
import { usePatientInsuranceModal } from "src/context/PatientInsuranceProvider/usePatientInsuranceModal";
import FileView from "src/shared/FileView";

interface Props {
  patientProfileId: string;
  allowActions?: boolean;
}

const PatientInsurance = ({
  patientProfileId,
  allowActions = false,
}: Props) => {
  const { data: files } = useGetPatientIdentificationQuery(
    patientProfileId != null
      ? { profileId: patientProfileId, folderName: "insurance" }
      : skipToken,
  );
  const { openInsuranceUploadModal } = usePatientInsuranceModal();

  return (
    <WhiteCard
      width="320px"
      maxHeight="315px"
      gap={1}
      sx={{ overflowY: "auto" }}
    >
      <Stack direction={"row"} alignItems={"center"}>
        <Typography variant="subtitle2">PATIENT INSURANCE</Typography>
        {allowActions ? (
          <Button
            variant="text"
            sx={{ ml: "auto" }}
            onClick={() => openInsuranceUploadModal(patientProfileId)}
          >
            {" "}
            Upload
          </Button>
        ) : null}
      </Stack>
      <Stack gap={1} direction="row">
        {files?.map((file) => (
          <FileView
            key={file.url}
            file={file}
            label={
              file.name.includes("front-of-card")
                ? "Front of card"
                : "Back of card"
            }
          />
        ))}
      </Stack>
    </WhiteCard>
  );
};

export default PatientInsurance;
